import { ResetFiltersButton } from "@/controls/buttons/ResetFiltersButton";
import { Box, TextField } from "@mui/material";

interface Props {
	search: string;
	onSearchChange: (value: string) => void;
	onReset: () => void;
	canReset: boolean;
}

// No "Add" button: the parameter set is fixed (from the tag catalog); this page
// only edits each parameter's limits.
export const StraightenerLimitsToolbar = ({
	search,
	onSearchChange,
	onReset,
	canReset,
}: Props) => (
	<Box
		sx={{
			display: "flex",
			alignItems: "center",
			gap: 1,
			flexWrap: "wrap",
			px: 1.5,
			py: 0.75,
		}}
	>
		<TextField
			size="small"
			placeholder="Search..."
			value={search}
			onChange={(e) => onSearchChange(e.target.value)}
			sx={{ width: 200 }}
		/>
		<ResetFiltersButton onClick={onReset} disabled={!canReset} />
	</Box>
);
